import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué pasa si dos antidepresivos no funcionan?",
    answer:
      "Si dos antidepresivos no han producido una mejoría suficiente, existen opciones autorizadas por la FDA como SAINT® para el trastorno depresivo mayor en adultos. El siguiente paso es una consulta con el equipo clínico.",
  },
];

export const esTwoAntidepressantsDontWork = makeEsArticle({
  slug: "what-happens-when-two-antidepressants-dont-work",
  title: "Qué pasa cuando dos antidepresivos no funcionan",
  description:
    "Si dos antidepresivos no han funcionado lo suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  h1: "Qué pasa cuando dos antidepresivos no funcionan",
  breadcrumbLabel: "Dos antidepresivos sin resultado",
  shortAnswer:
    "Cuando dos antidepresivos no han producido una mejoría suficiente, existen opciones autorizadas por la FDA para el trastorno depresivo mayor. SAINT® es una TMS acelerada con orientación por fMRI, administrada en cinco días, indicada para adultos que no han mejorado con antidepresivos. No hay garantías de resultados; los resultados individuales pueden variar. El siguiente paso es una consulta con el equipo clínico.",
  keyTakeaways: [
    "Si dos antidepresivos no funcionan, aún hay opciones.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "No hay garantías; los resultados pueden variar.",
    "El siguiente paso es una consulta.",
  ],
  sections: [
    {
      heading: "Opciones disponibles",
      paragraphs: [
        "Cuando varios antidepresivos no han funcionado lo suficiente, el trastorno depresivo mayor puede calificarse como resistente al tratamiento. En ese punto, las opciones autorizadas por la FDA incluyen la TMS convencional y SAINT®.",
        "SAINT® combina 50 sesiones en cinco días con orientación individualizada por fMRI y patrón theta burst. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
